/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SelectGenerictemDTO { 
    tenant?: string;
    partner?: string;
    id?: string;
    label?: string;
    title?: string;
    disable?: boolean;
}